import React, { useState } from 'react';
import CourseMessages from './CourseMessages';
import DisplayUploads from './DisplayUploads';
import DisplayAssignments from './DisplayAssignments';
import { API_BASE_URL } from './Constants';
import { useEffect } from 'react';
import axios from 'axios';
import AttendanceList from './AttendenceList';
import DisplayAssessments from './DisplayAssessments';
import img from "./images-com/supalearn.png"; 
import img2 from "./images-com/attendance.png";
const StudentTab = (props) => {
  const [activeTab, setActiveTab] = useState('resources');
    const id = props.id;
    const studentId = props.studentId;
    const [enrollments, setEnrollments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    

     useEffect(() => {
        const fetchEnrollments = async () => {
          try {
            const res = await axios.get(`${API_BASE_URL}/api/enrollments`);
            const courseData = res.data;
            const filteredData = courseData.filter(courseData => courseData.id === id);
            setEnrollments(filteredData);
            setLoading(false);
          } catch (err) {
            console.error('Error fetching enrollments', err);
            setError('Failed to load enrollments');
            setLoading(false);
          }
        };
    
        fetchEnrollments();
      }, []);
  // Sample data for each tab
  const tabData = {
    resources: [
      { id: 1, name: 'React Documentation', type: 'Document', date: '2023-10-15' },
      { id: 2, name: 'CSS Tutorial', type: 'Video', date: '2023-10-10' },
      { id: 3, name: 'JavaScript Basics', type: 'PDF', date: '2023-10-05' }
    ],
    assignments: [
      { id: 1, title: 'React Component Project', dueDate: '2023-10-20', status: 'Pending' },
      { id: 2, title: 'CSS Styling Assignment', dueDate: '2023-10-18', status: 'Submitted' },
      { id: 3, title: 'JavaScript Exercises', dueDate: '2023-10-12', status: 'Graded' }
    ],
    assessments: [
      { id: 1, title: 'Midterm Exam', date: '2023-11-05', weight: '30%' },
      { id: 2, title: 'Quiz 1', date: '2023-10-25', weight: '10%' },
      { id: 3, title: 'Final Project', date: '2023-12-15', weight: '40%' }
    ],
    messages: [
      { id: 1, from: 'John Doe', subject: 'Question about assignment', date: '2023-10-16', read: false },
      { id: 2, from: 'Jane Smith', subject: 'Meeting request', date: '2023-10-15', read: true },
      { id: 3, from: 'Admin', subject: 'System update', date: '2023-10-14', read: true }
    ],
    students: [
      { id: 1, name: 'John Doe', email: 'john@example.com', enrolled: '2023-09-01' },
      { id: 2, name: 'Jane Smith', email: 'jane@example.com', enrolled: '2023-09-01' },
      { id: 3, name: 'Mike Johnson', email: 'mike@example.com', enrolled: '2023-09-05' }
    ],
    attendance: [
      { id: 1, date: '2023-10-16', present: 25, absent: 2 },
      { id: 2, date: '2023-10-15', present: 24, absent: 3 },
      { id: 3, date: '2023-10-14', present: 26, absent: 1 }
    ]
  };

  // Render appropriate content based on active tab
  const renderTabContent = () => {
    
    switch(activeTab) {
      case 'resources':
        return (
          <>
          <div className="flex items-center mb-6 bg-purple-300 p-4 rounded-lg">
            <div>
                <a
                  href="https://www.supalearn.in/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center"
                >
                  <img src={img} alt="Documents" className="w-24 h-24 mb-0 mx-auto" />
                </a>
                <span className="text-lg font-bold">Supalearn</span>
                </div>

                 <div>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfRBRlEA2z3NI6j-wQ1zlLUnf-ZN5VgQH6UJga_-3cHzQhcDg/viewform?usp=publish-editor"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center"
                >
                  <img src={img2} alt="Documents" className="w-24 h-24 mb-0 mx-auto" />
                </a>
                <span className="text-lg font-bold">Attendance</span>
                </div>
              </div>
                 
               
    
                  <hr />
          <DisplayUploads id={id} />
          </>
        );
      case 'assignments':
        return (
            <DisplayAssignments id={id} />
          // <div className="overflow-x-auto">
          //   <table className="table table-zebra w-full">
          //     <thead>
          //       <tr>
          //         <th>Title</th>
          //         <th>Due Date</th>
          //         <th>Status</th>
          //         <th>Action</th>
          //       </tr>
          //     </thead>
          //     <tbody>
          //       {tabData.assignments.map(item => (
          //         <tr key={item.id}>
          //           <td className="font-bold">{item.title}</td>
          //           <td>{item.dueDate}</td>
          //           <td>
          //             <span className={`badge ${item.status === 'Submitted' ? 'badge-success' : item.status === 'Pending' ? 'badge-warning' : 'badge-info'}`}>
          //               {item.status}
          //             </span>
          //           </td>
          //           <td><button className="btn btn-sm btn-outline">View</button></td>
          //         </tr>
          //       ))}
          //     </tbody>
          //   </table>
          // </div>
        );
      case 'assessments':
        return (
          <div className="overflow-x-auto">
             <DisplayAssessments id={id} />
            {/* <table className="table table-zebra w-full">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Date</th>
                  <th>Weight</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tabData.assessments.map(item => (
                  <tr key={item.id}>
                    <td className="font-bold">{item.title}</td>
                    <td>{item.date}</td>
                    <td>{item.weight}</td>
                    <td><button className="btn btn-sm btn-outline">Details</button></td>
                  </tr>
                ))}
              </tbody>
            </table> */}
          </div>
        );
      case 'messages':
        return (
          <div className="space-y-4">

            <CourseMessages id={id} senderId={studentId} />
          </div>
        );
      case 'students':
        return (
          <div className="overflow-x-auto">
            <table className="table table-zebra w-full">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Enrollment Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tabData.students.map(student => (
                  <tr key={student.id}>
                    <td>
                      <div className="flex items-center gap-3">
                        <div className="avatar placeholder">
                          <div className="bg-neutral text-neutral-content rounded-full w-8">
                            <span className="text-xs">{student.name.charAt(0)}</span>
                          </div>
                        </div>
                        <div>
                          <div className="font-bold">{student.name}</div>
                        </div>
                      </div>
                    </td>
                    <td>{student.email}</td>
                    <td>{student.enrolled}</td>
                    <td><button className="btn btn-sm btn-outline">Profile</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      case 'attendance':
        return (
          <div className="overflow-x-auto">
            <AttendanceList enrollId={id} studentId={studentId} />
            {/* <table className="table table-zebra w-full">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Present</th>
                  <th>Absent</th>
                  <th>Percentage</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tabData.attendance.map(record => {
                  const percentage = ((record.present / (record.present + record.absent)) * 100).toFixed(1);
                  return (
                    <tr key={record.id}>
                      <td className="font-bold">{record.date}</td>
                      <td>
                        <span className="badge badge-success badge-lg">{record.present}</span>
                      </td>
                      <td>
                        <span className="badge badge-error badge-lg">{record.absent}</span>
                      </td>
                      <td>
                        <div className="flex items-center gap-2">
                          <div className="radial-progress bg-base-200 border-4 border-base-200" 
                               style={{"--value": percentage, "--size": "3rem", "--thickness": "3px"}}>
                            <span className="text-xs font-bold">{percentage}%</span>
                          </div>
                        </div>
                      </td>
                      <td><button className="btn btn-sm btn-outline">Details</button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table> */}
          </div>
        );
      default:
        return <div>Select a tab to view content</div>;
    }
  };

  return (
    <>
    
    <div className="p-6 min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
       {!loading && <div className='flex justify-center mb-4'><span className='bg-secondary text-white p-2 rounded-lg'>👩‍🏫{enrollments.length > 0 ? (enrollments[0].tutor.name+'-'+enrollments[0].tutor.tag.toString().padStart(3, '0')): 'No Student Selected'}</span></div>}
     
      <div className="max-w-7xl mx-auto">
        {/* <h1 className="text-4xl font-bold mb-2 text-center text-indigo-800">Education Dashboard</h1>
        <p className="text-lg text-center text-indigo-600 mb-8">Manage your educational resources and activities</p> */}
        
        {/* Tabs Navigation - Made wider with better styling */}
        <div className="flex justify-center mb-8">
          <div role="tablist" className="tabs tabs-boxed bg-white/80 backdrop-blur-sm rounded-xl p-1 w-full max-w-6xl shadow-lg">
            <button
              role="tab"
              className={`tab text-lg font-medium ${activeTab === 'resources' ? 'tab-active bg-indigo-500 text-white' : 'text-indigo-700'}`}
              onClick={() => setActiveTab('resources')}
            >
              📚 Resources
            </button>
            <button
              role="tab"
              className={`tab text-lg font-medium ${activeTab === 'assignments' ? 'tab-active bg-indigo-500 text-white' : 'text-indigo-700'}`}
              onClick={() => setActiveTab('assignments')}
            >
              📝 Assignments
            </button>
            <button
              role="tab"
              className={`tab text-lg font-medium ${activeTab === 'assessments' ? 'tab-active bg-indigo-500 text-white' : 'text-indigo-700'}`}
              onClick={() => setActiveTab('assessments')}
            >
              📊 Assessments
            </button>
            <button
              role="tab"
              className={`tab text-lg font-medium ${activeTab === 'messages' ? 'tab-active bg-indigo-500 text-white' : 'text-indigo-700'}`}
              onClick={() => setActiveTab('messages')}
            >
              ✉️ Messages
            </button>
            {/* <button
              role="tab"
              className={`tab text-lg font-medium ${activeTab === 'students' ? 'tab-active bg-indigo-500 text-white' : 'text-indigo-700'}`}
              onClick={() => setActiveTab('students')}
            >
              👥 Students
            </button> */}
            <button
              role="tab"
              className={`tab text-lg font-medium ${activeTab === 'attendance' ? 'tab-active bg-indigo-500 text-white' : 'text-indigo-700'}`}
              onClick={() => setActiveTab('attendance')}
            >
              ✅ Attendance
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-2xl shadow-xl p-6">
          <div className="mb-6 flex justify-between items-center">
            <h2 className="text-2xl font-bold text-indigo-800 capitalize">{activeTab}</h2>
            <div className="text-sm breadcrumbs">
              <ul>
                <li><a>Dashboard</a></li> 
                <li className="capitalize">{activeTab}</li>
              </ul>
            </div>
          </div>
          
          {renderTabContent()}
        </div>
      </div>
    </div>
    </>
  );
};

export default StudentTab;